// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__Nnw8F","focado":"OptionSelect_focado__ESoFA"};